import { FilterProps } from "store/common";

export const getDefaultInputValue = (val: any, defaultVal?: any) => {
  return {
    value: val ? val : defaultVal,
    isTouched: val ? true : false,
  };
};

export const createFilterProps = (filter: FilterProps): FilterProps => {
  let res = {};

  let isFilterApplied = false;
  if (filter?.minDate) {
    isFilterApplied = true;
  } else if (filter?.maxDate) {
    isFilterApplied = true;
  } else if (filter?.searchKeyword) {
    isFilterApplied = true;
  } else if (filter?.dueDate) {
    isFilterApplied = true;
  } else if (filter?.pastDue) {
    isFilterApplied = true;
  } else if (filter?.autoPay) {
    isFilterApplied = true;
  } else if (filter?.confirmationNumber) {
    isFilterApplied = true;
  } else if (filter?.status) {
    isFilterApplied = true;
  } else if (filter?.paymentMethodType) {
    isFilterApplied = true;
  } else if (filter?.accountNumber) {
    isFilterApplied = true;
  } else if (filter?.excludeErrorStatus !== undefined) {
    isFilterApplied = true;
  }
  if (isFilterApplied) {
    res = filter;
  }

  return res;
};
